"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyForm = void 0;
var _mui = require("@ori-ui/mui");
var _logger = require("@ori/logger");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _zod = require("zod");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DATA_TESTID = 'data-testid';
const NotifyForm = ({
  currentType,
  inputData,
  onSubmit,
  onChange,
  productCode
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    subscribe
  } = (0, _contexts.useAppContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const localLogger = (0, _logger.useLogger)('NotifyForm');
  const isEmail = _models.BackInStockNotificationChannel.Email === currentType;
  const isCorrectInputData = isEmail ? _zod.z.string().email().safeParse(inputData).success : _zod.z.string().regex(/^\+?\d+$/).safeParse(inputData).success;
  const isInvalid = inputData.length === 0 || !isCorrectInputData;
  const [submitLoading, setSubmitLoading] = (0, _react.useState)(false);
  const [isSubmitted, setIsSubmitted] = (0, _react.useState)(false);
  const isSubmittedWithInvalidData = isInvalid && isSubmitted;
  const errorLabel = (0, _react.useMemo)(() => isEmail ? translations.invalidEmail : translations.invalidTelephoneNumber, [isEmail, translations.invalidEmail, translations.invalidTelephoneNumber]);
  const onClick = (0, _react.useCallback)(async event => {
    event.preventDefault();
    setIsSubmitted(true);
    if (!isCorrectInputData) {
      return;
    }
    try {
      setSubmitLoading(true);
      await subscribe(isEmail ? {
        notificationChannel: _models.BackInStockNotificationChannel.Email,
        itemCode: productCode,
        email: inputData
      } : {
        notificationChannel: _models.BackInStockNotificationChannel.Sms,
        itemCode: productCode,
        telephoneNumber: inputData
      });
      onSubmit();
    } catch (error) {
      // istanbul ignore next @preserve -- No need to test graphql error handling.
      localLogger.error(new Error('SubmitButton onClick', {
        cause: error
      }), {
        productCode,
        inputData
      });
    } finally {
      setSubmitLoading(false);
    }
  }, [isCorrectInputData, subscribe, isEmail, productCode, inputData, onSubmit, localLogger]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.NOTIFY_FORM),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Form, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Field, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
          required: true,
          label: currentType,
          variant: "standard",
          type: "text",
          value: inputData,
          error: isSubmittedWithInvalidData,
          helperText: isSubmittedWithInvalidData ? errorLabel : undefined,
          inputProps: {
            [DATA_TESTID]: getTestId(_constants.NOTIFY_FORM_INPUT)
          },
          onChange: onChange
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubmitButton, {
      fullWidth: true,
      variant: "contained",
      color: "primary",
      "data-testid": getTestId(_constants.NOTIFY_FORM_SUBMIT),
      loading: submitLoading,
      onClick: onClick,
      children: translations.submitNotification
    })]
  });
};
exports.NotifyForm = NotifyForm;